import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-accordion-item q-w-100" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["aria-expanded", "aria-controls"]
const _hoisted_4 = ["id", "aria-labelledby"]
const _hoisted_5 = { class: "q-accordion-body q-p-1" }

import {ref} from "vue";
import QueriesList from './QueriesList.vue';
import ClearQueriesButton from "@/components/AutocompletePopup/OnFocus/Queries/ClearQueriesButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionQueries',
  props: ['queriesHeader', 'queries', 'canRemove'],
  setup(__props) {

const props = __props;
const sectionId = ref(normalizeText(props.queriesHeader));
const headerId = ref(`header_${sectionId.value}`);
const isCollapsed = ref(true);

function normalizeText(text: string): string {
  return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '');
}

function toggleAccordion() {
  isCollapsed.value = !isCollapsed.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "q-accordion-header q-position-relative q-w-100",
      id: headerId.value
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["q-btn q-btn-sm q-accordion-button q-rotatable q-w-100", {'q-collapsed': isCollapsed.value,
               'q-rotated': !isCollapsed.value
              }]),
        type: "button",
        onClick: toggleAccordion,
        "aria-expanded": !isCollapsed.value.toString(),
        "aria-controls": sectionId.value
      }, _toDisplayString(__props.queriesHeader), 11, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      id: sectionId.value,
      class: _normalizeClass(["q-accordion-collapse", {'q-collapse': isCollapsed.value, 'q-show': !isCollapsed.value}]),
      "aria-labelledby": headerId.value
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(QueriesList, {
          queries: __props.queries,
          "can-remove": __props.canRemove
        }, null, 8, ["queries", "can-remove"]),
        (__props.canRemove)
          ? (_openBlock(), _createBlock(ClearQueriesButton, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ], 10, _hoisted_4)
  ]))
}
}

})